import React from 'react';
import { CheckoutView } from './CheckoutView';
import { useCheckout } from './hooks/useCheckout';
export const CheckoutContainer = () => {
    const { checkout } = useCheckout();
    return (React.createElement(CheckoutView, { initialValues: checkout.initialValues, currency: checkout.currency, abandonedCheckout: checkout.abandonedCheckout, onSubmit: checkout.onSubmit }));
};
